var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['list-item', _vm.classes]},[_c(_vm.getComponentType,_vm._b({tag:"component"},'component',_vm.getComponentProps,false),[(_vm.item.image)?_c('img',{attrs:{"src":_vm.pathForImage(_vm.item),"alt":_vm.item.image}}):_vm._e(),_vm._v(" "),(_vm.item.label)?_c('span',[_vm._v(_vm._s(_vm.item.label))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }